<script>
    export default {
        name: "LogoutRedirect",
        computed: {
            isAuthPending() {
                return this.$store.state.account.isAuthPending;
            },
            isLogged() {
                return this.$store.state.account.isLogged;
            }
        },
        methods: {
            redirectToLoginPage() {
                this.$router.push('/login').then(res => {}).catch(err => {console.log(err)});
            }
        },
        created() {
            if(!this.isAuthPending && !this.isLogged) {
                this.redirectToLoginPage();
            }
        },
        watch: {
            isAuthPending(newValue, oldValue) {
                if (oldValue && !newValue && !this.isLogged) {
                    this.redirectToLoginPage();
                }
            },
            isLogged(newValue, oldValue) {
                if(!newValue) {
                    this.redirectToLoginPage();
                }
            }
        },

    }
</script>

<style scoped>

</style>
